import Button from '../../Components/Button';
import { formatNumbers, numberWithCommas } from '../../helpers';
import CoinReward from '../../assets/svg/utils/coins/coin_reward.svg';
import RocketIcon from '../../assets/svg/utils/rocket/rocket_reward.svg';
import Energy from '../../assets/svg/utils/energy/energy-ltr.svg';
import { TPageState } from './types';
import { CharacterUpdateRewardsResponse, IProfileStore, RewardsT } from '../../types';

type UpgradeButtonsProps = {
  isNextUpgradeLoaded: boolean
  pageState: TPageState
  fullUpgrade: boolean
  handleUpgrade: () => void
  handleClaimRewards: () => void
  handleBackToUpgrade: () => void
  characterUpdatePending: boolean
  upgradePrice: number
  characterUpdateRewards: IProfileStore['characterUpdateRewards']
}

function UpgradeButtons({
  isNextUpgradeLoaded, pageState, fullUpgrade, handleUpgrade, characterUpdatePending,
  upgradePrice,
  characterUpdateRewards,
  handleClaimRewards,
  handleBackToUpgrade,
}: UpgradeButtonsProps) {
  const aggregateRewards = (rewardsArray: { rewards: RewardsT }[]): RewardsT => rewardsArray.reduce((acc: RewardsT, reward) => {
    // eslint-disable-next-line no-restricted-syntax
    for (const key of Object.keys(reward.rewards) as (keyof RewardsT)[]) {
      acc[key] = (Number(acc[key] || 0)) + (Number(reward.rewards[key] || 0));
    }
    return acc;
  }, {} as RewardsT);
  const aggregatedRewards = aggregateRewards((characterUpdateRewards || []) as CharacterUpdateRewardsResponse);
  return (
    <div className="fixed bottom-[11vh] w-full px-4 z-[22]">
      {/* <div className="absolute bottom-[11vh] w-full left-0 px-4 z-[22]"> */}
      {(isNextUpgradeLoaded && (pageState === 'upgrade' || pageState === 'not-enough-funds') && !fullUpgrade)
            && (
            <Button
              onClick={handleUpgrade}
              disabled={characterUpdatePending}
              className="btn upgrade gradient-border upgrade-gradient w-full py-4 flex items-center justify-center text-2xl text-purpleText font-Bangers leading-[25.54px] gap-1 rounded-[16px] z-[100]"
              withoutTransform
              style={{
                visibility: 'visible',
              }}
            >
              <div className="flex items-center justify-center upgrade-text">
                Upgrade For
                {' '}
                {numberWithCommas(upgradePrice)}
                <img
                  src={CoinReward}
                  alt="coin-icon"
                  className="w-[28px] ml-1 translate-y-[0px] translate-x-[5px]"
                />
              </div>
            </Button>
            )}
      {!!(characterUpdateRewards?.length && pageState === 'claim-reward')
            && (
            <div className="font-Bangers text-black-text text-xl flex items-center justify-between">
              {aggregatedRewards?.rocket_coins_recovery_per_hour
                        && (
                        <div className="flex gap-1 items-center">
                          <img src={RocketIcon} alt="rocket-icon" className="w-[30px]" />
                          {' '}
                          +
                          {aggregatedRewards.rocket_coins_recovery_per_hour}
                          /hr
                        </div>
                        )}
              {aggregatedRewards?.energy
                        && (
                        <div className="flex gap-1 items-center">
                          <img src={Energy} alt="energy-icon" className="w-[32px] translate-y-[-3px]" />
                          {' '}
                          +
                          {formatNumbers(Number(10 || 0), 3, 10 > 100_000)}
                          {' '}
                          SPINS
                        </div>
                        )}
              {aggregatedRewards?.coins
                        && (
                        <div className="flex gap-1 items-center">
                          <img src={CoinReward} alt="coin-icon" className="w-[28px]" />
                          {' '}
                          +
                          {formatNumbers(Number(aggregatedRewards.coins || 0), 3, aggregatedRewards.coins > 100_000)}
                        </div>
                        )}
            </div>
            )}
      {pageState === 'claim-reward'
            && (
            <Button
              onClick={handleClaimRewards}
              disabled={characterUpdatePending}
              className="btn upgrade gradient-border upgrade-gradient w-full py-4 flex items-center justify-center text-2xl text-purpleText font-Bangers leading-[25.54px] gap-1 rounded-[16px] z-[100]"
            >
              <div className="flex items-center justify-center upgrade-text">
                claim rewards
              </div>
            </Button>
            )}
      {(pageState === 'unlocked')
          && (
          <Button
            onClick={handleBackToUpgrade}
            disabled={characterUpdatePending}
            className="btn upgrade gradient-border upgrade-gradient w-full py-4 flex items-center justify-center text-2xl text-purpleText font-Bangers leading-[25.54px] gap-1 rounded-[16px] z-[100]"
          >
            <div className="flex items-center justify-center upgrade-text">
              Back to upgrade
            </div>
          </Button>
          )}
    </div>
  );
}

export default UpgradeButtons;
